const fingerName = "userfinger";
const prefixAnswerName = "answerData";
export const getFinger = () => {
  return localStorage.getItem(fingerName);
};

export const setFinger = (data) => {
  return localStorage.setItem(fingerName, data);
};

export const setAnswer = (id,data) => {
  localStorage.setItem(`${prefixAnswerName}-${id}`, JSON.stringify(data));
};

export const getAnswer = (id) => {
  let data = localStorage.getItem(`${prefixAnswerName}-${id}`);
  if (data) return JSON.parse(data);
  else return undefined;
};

export const removeAnswer = (id) => {
  localStorage.removeItem(`${prefixAnswerName}-${id}`);
};
